import { get } from './apiClient';

export interface EnvironmentDefaults {
  rootDomains: {
    app: string;
    local: string;
  };
  namespaces: {
    prod: string;
    dev: string;
    demo: string;
  };
  jwksLocal: {
    host: string;
    port: number;
  };
  secretStores: {
    nonLocal: string;
    localAzure: string;
    localConsul: string;
  };
  localInfra: {
    consulAddr: string;
    vaultAddr: string;
  };
  // Client secrets are never returned by the server — only clientId/tenantId to prepopulate the form.
  azureAdIdp: {
    prod: { tenantId: string; clientId: string };
    dev: { tenantId: string; clientId: string };
    demo: { tenantId: string; clientId: string };
  };
}

export interface ApiResponse<T> {
  success: boolean;
  data: T;
  message?: string;
}

/**
 * Fetch the config-driven tenant-provisioning defaults (domains, namespaces, JWKS, secret
 * store names, Consul/Vault addresses, Azure AD federation) used to pre-populate the
 * Provision Tenant wizard based on the selected environment and local/on-prem toggle.
 */
export const getEnvironmentDefaults = (): Promise<ApiResponse<EnvironmentDefaults>> =>
  get<ApiResponse<EnvironmentDefaults>>('/environment-config');
